import SelectWrapper from "../../StylesWrappers/General/selectOption";
import { SelectOptionProps } from "../../model";

const SelectOption: React.FC<SelectOptionProps> = ({
  statusName,
  statusValue,
  selectName,
  optionOne,
  optionTwo,
  optionThree,
  optionFour,
  optionFive,
  optionSix,
  optionSeven,
  optionEight,
  optionController,
  valueOne,
  valueTwo,
  valueThree,
  valueFour,
  valueFive,
  valueSix,
  valueSeven,
  valueEight,
  handleSelect,
}) => {
  return (
    <SelectWrapper>
      <p>{selectName}</p>
      <select name={statusName} value={statusValue} onChange={handleSelect}>
        <option value="">_Make a selection_</option>
        <option value={valueOne}>{optionOne}</option>
        <option value={valueTwo}>{optionTwo}</option>
        <option value={valueThree}>{optionThree}</option>
        {optionController === "jobType" ? (
          <>
            <option value={valueFour}>{optionFour}</option>
            <option value={valueFive}>{optionFive}</option>
            <option value={valueSix}>{optionSix}</option>
            <option value={valueSeven}>{optionSeven}</option>
            <option value={valueEight}>{optionEight}</option>
          </>
        ) : (
          ""
        )}
      </select>
    </SelectWrapper>
  );
};

export default SelectOption;
